export default __webpack_public_path__ + "static/media/location.c6c3d508.svg";